export default __webpack_public_path__ + "static/media/9_16-clip-ad-mobile.b9e85387.png";